import { Injectable } from "@angular/core";
import { RatingService } from "@edp-services/rating.service";
import { ELayoutActions, ShowLoader } from "@edp-store/actions/layout.actions";
import { ERatingActions, SubmitRating } from "@edp-store/actions/rating.actions";
import { IAppState } from "@edp-store/state/app.state";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { EMPTY, of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";

@Injectable()
export class RatingEffects {
    getRatingStatus$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ERatingActions.GetRatingStatus),
            switchMap(() => {
                this.store.dispatch(new ShowLoader(true));
                return this.ratingService.getRatingStatus().pipe(
                    switchMap(response => [
                        { type: ERatingActions.SaveRatingStatus, payload: response },
                        { type: ELayoutActions.ShowLoader, payload: false },
                    ]),
                    catchError(() => EMPTY)
                );
            })
        )
    );

    submitRatingStatus$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ERatingActions.SubmitRating),
            switchMap((action: SubmitRating) => {
                this.store.dispatch(new ShowLoader(true));
                return this.ratingService.submitRating(action.payload).pipe(
                    switchMap(() => {
                        return of(
                            {
                                type: ERatingActions.SaveRatingStatus,
                                payload: { ...action.payload, messageType: "SUCCESS" },
                            },
                            { type: ELayoutActions.ShowLoader, payload: false }
                        );
                    }),
                    catchError(() =>
                        of(
                            { type: ERatingActions.SaveRatingStatus, payload: { messageType: "ERROR" } },
                            { type: ELayoutActions.ShowLoader, payload: false }
                        )
                    )
                );
            })
        )
    );

    constructor(private actions$: Actions, private ratingService: RatingService, private store: Store<IAppState>) {}
}
